import { useEffect, useState } from 'react';
import { HashRouter } from 'react-router-dom';
import './App.scss';
import Layout from './pages/Layout/Layout';
import CryptoJS from "crypto-js";
import { SecretKeys } from './shared/Constants/SecretKey';
import { decryptFunction, sessionService } from './shared/Utils/SessionService';
import { authorizationService } from './shared/api_services/authorizationService';
import { getURLDataMethod } from './shared/Utils/Utils';

function App() {
  let secretKey: any = SecretKeys.cryptoSecretKey;
  const [urlDefinedData, setUrlDefinedData] = useState<any>();

  useEffect(() => {
    if (localStorage.getItem('activeSession') === null) {
      let tempSession: any = {
        "currentSession": true,
        "hasURLDetails": getURLDataMethod() ? true : false,
      }
      localStorage.setItem('activeSession', CryptoJS.AES.encrypt(JSON.stringify(tempSession), secretKey).toString())
      window.location.reload();
    }
    else if (localStorage?.getItem('activeSession')) {
      if (decryptFunction("activeSession")?.["currentSession"] === false) {
        loadListOfDevicesDetected()
      }
      else if (decryptFunction("activeSession")?.["currentSession"] === true) {
        let tempSession: any = {
          "currentSession": true,
          "hasURLDetails": getURLDataMethod() ? true : false,
        }
        localStorage.setItem('activeSession', CryptoJS.AES.encrypt(JSON.stringify(tempSession), secretKey).toString())
      }
    }
    setUrlDefinedData(decryptFunction("activeSession"))
  }, [])

  // checking whether session is active in Asset Manager
  const loadListOfDevicesDetected = async () => {
    let details: any = getURLDataMethod();
    const payload = JSON.parse(JSON.stringify(details));
    if (payload && payload['firmware_version']) {
      const device = payload['device_type']?.split('iLens-')[1];
      try {
        return await authorizationService.detectedDevicesList("DetectedDevicesList", payload, device, payload['firmware_version']).then((res: any) => {
          if (res.status === 200) {
            if (res.body) {
              let tempSession: any = {
                "currentSession": true,
                "hasURLDetails": getURLDataMethod() ? true : false,
              }
              localStorage.setItem('activeSession', CryptoJS.AES.encrypt(JSON.stringify(tempSession), secretKey).toString())
              window.location.reload();
            }
          }
        })
      } catch (err: any) {
        console.log(err);
      }
    }
  }

  return (
    <>
      <HashRouter>
        <Layout urlCarryData={urlDefinedData} />
      </HashRouter>
    </>
  );
}

export default App;
